var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStandard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.03122 7.43386L9.0121 4.17027C9.43779 3.94324 9.94861 3.94324 10.3743 4.17027L17.1285 7.85246C17.3555 7.98016 17.4974 8.21429 17.4974 8.47679V13.0245C17.4974 13.4147 17.1782 13.734 16.788 13.734C16.3977 13.734 16.0785 13.4147 16.0785 13.0245V8.83153L10.3743 11.9461C9.94861 12.1803 9.43779 12.1803 9.0121 11.9461L3.03122 8.68254C2.54168 8.41294 2.54168 7.70347 3.03122 7.43386ZM4.72663 12.6556V10.3143L9.01187 12.6556C9.43755 12.8897 9.94838 12.8897 10.3741 12.6556L14.6593 10.3143V12.6556C14.6593 13.365 12.9184 15.3516 9.72579 15.3516C6.53315 15.3516 4.72663 13.365 4.72663 12.6556Z",
    fill: "#84849A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStandard);
export default __webpack_public_path__ + "static/media/standard.c115f2a8.svg";
export { ForwardRef as ReactComponent };